import { createBrowserRouter, } from "react-router-dom";
import { MainLayout, } from "./pages/MainLayout";
import { ErrorPage, } from "./pages/ErrorPage";
import { LoginPage, } from "./pages/Login/LoginPage";
import { LoginPageLayout, } from "./pages/Login/LoginPageLayout";
import { OtpPage, } from "./pages/Login/OtpPage";
import { PinPage, } from "./pages/Login/PinPage";
import { MainPage, } from "./pages/MainPage";
import { HowToPage, } from "./pages/HowToPage";
import { OperationPage, } from "./pages/Operations/OperationPage";
import { PaymentPage, } from "./pages/Payment/PaymentPage";
import { PartialPaymentPage, } from "./pages/Payment/PartialPaymentPage";
import { PaymentSuccessPage, } from "./pages/Payment/PaymentSuccessPage";
import { OperationsPage, } from "./pages/Operations/OperationsPage";
import { ProfilePage, } from "./pages/ProfilePage";
import { CardConnectedPage, } from "./pages/Card/Connected";
import { CardErrorPage, } from "./pages/Card/Error";
// import { EmailPage, } from "./pages/CardIssuance/EmailPage";
import { PassportPage, } from "./pages/Login/PassportPage";
import { LimitPage, } from "./pages/Limits/LimitPage";
import { PaymentsPage, } from "./pages/Payments/PaymentsPage";
// import { OverviewPage, } from "./pages/CardIssuance/OverviewPage";
// import { CardStatusPage, } from "./pages/CardIssuance/CardStatusPage";
// import { CardOtpPage, } from "./pages/CardIssuance/CardOtpPage";
// import { CardOpenedPage, } from "./pages/CardIssuance/CardOpenedPage";
// import { CardErrorPage as IssuedCardErrorPage, } from "./pages/CardIssuance/CardErrorPage";
// import { EmailOtpPage, } from "./pages/CardIssuance/EmailOtpPage";
import { QrPage, } from "./pages/QR/QrPage";
import { QrPaymentPage, } from "./pages/QR/QrPaymentPage";
import { YMPageTracker, } from "./components/features/YMPageTracker";

export const RoutesMap = {
  index: "/",
  payment: {
    index: `/payment`,
  },
  issuance: {
    index: "/issuance",
    email: "/issuance/:limid/email",
    emailOtp: "/issuance/:limid/email-otp",
    overview: "/issuance/:limid/overview",
    status: "/issuance/:limid/status",
    otp: "/issuance/:limid/otp",
    opened: "/issuance/:limid/opened",
    error: "/issuance/:limid/error",
  },
  login: {
    index: "/login",
    otp: "/login/otp",
    passport: "/login/passport",
    pin: "/login/pin",
  },
  howto: "/howto",
  profile: "/profile",
  card: {
    connected: "/card/connected",
    error: "/card/error",
  },
  operations: {
    index: "/operations",
    operation: "/operations/:id",
    payment: {
      index: "/operations/:id/payment",
      partial: "/operations/:id/payment/partial",
      success: "/operations/:id/payment/success",
    },
  },
  limits: {
    limit: "/limits/:id",
  },
  payments: {
    index: "/payments",
    payment: "/payments/payment",
  },
  qr: {
    index: "/qr",
    payment: "/qr/payment",
  },
} as const;

/**
 * This is the application's routing tree. Page components contain loader functions to reduce
 * the size of the codebase and to separate logic. Typically, loader functions are used
 * to execute `queryClient.prefetch` with ReactQuery.
 */
export const routes = () => createBrowserRouter([{
  path: "/",
  element: (
    <>
      <YMPageTracker />
      <MainLayout />
    </>
  ),
  loader: MainLayout.loader,
  errorElement: <ErrorPage />,
  children: [{
    path: RoutesMap.card.connected,
    element: <CardConnectedPage />,
  }, {
    path: RoutesMap.card.error,
    element: <CardErrorPage />,
  }, {
    path: RoutesMap.profile,
    element: <ProfilePage />,
  }, {
    path: RoutesMap.operations.payment.partial,
    element: <PartialPaymentPage />,
    loader: PartialPaymentPage.loader,
  }, {
    path: RoutesMap.operations.payment.success,
    element: <PaymentSuccessPage />,
    loader: PaymentSuccessPage.loader,
  }, {
    path: RoutesMap.howto,
    element: <HowToPage />,
    loader: HowToPage.loader,
  }, {
    path: RoutesMap.index,
    element: <MainPage />,
    loader: MainPage.loader,
    children: [{
      path: RoutesMap.payment.index,
      element: <PaymentPage />,
      loader: PaymentPage.loader,
    }, {
      path: RoutesMap.qr.payment,
      element: <QrPaymentPage />,
      loader: QrPaymentPage.loader,
    },],
  }, {
    path: RoutesMap.operations.index,
    children: [{
      path: RoutesMap.operations.index,
      element: <OperationsPage />,
      loader: OperationsPage.loader,
    }, {
      path: RoutesMap.operations.operation,
      element: <OperationPage />,
      loader: OperationPage.loader,
      children: [{
        path: RoutesMap.operations.payment.index,
        element: <PaymentPage />,
        loader: PaymentPage.loader,
      },],
    },],
  }, {
    path: RoutesMap.limits.limit,
    element: <LimitPage />,
  }, {
    path: RoutesMap.payments.index,
    element: <PaymentsPage />,
    children: [{
      path: RoutesMap.payments.payment,
      element: <PaymentPage />,
      loader: PaymentPage.loader,
    },],
  },
  // {
  //   path: RoutesMap.issuance.index,
  //   children: [{
  //     path: RoutesMap.issuance.email,
  //     element: <EmailPage />,
  //     loader: EmailPage.loader,
  //   }, {
  //     path: RoutesMap.issuance.emailOtp,
  //     element: <EmailOtpPage />,
  //     loader: EmailOtpPage.loader,
  //   }, {
  //     path: RoutesMap.issuance.overview,
  //     element: <OverviewPage />,
  //     loader: OverviewPage.loader,
  //   }, {
  //     path: RoutesMap.issuance.status,
  //     element: <CardStatusPage />,
  //   }, {
  //     path: RoutesMap.issuance.otp,
  //     element: <CardOtpPage />,
  //     loader: CardOtpPage.loader,
  //   }, {
  //     path: RoutesMap.issuance.opened,
  //     element: <CardOpenedPage />,
  //   }, {
  //     path: RoutesMap.issuance.error,
  //     element: <IssuedCardErrorPage />,
  //   },],
  // },
  {
    path: RoutesMap.qr.index,
    element: <QrPage />,
  }, {
    path: RoutesMap.login.index,
    element: <LoginPageLayout />,
    loader: LoginPageLayout.loader,
    children: [{
      path: RoutesMap.login.index,
      element: <LoginPage />,
      loader: LoginPage.loader,
    }, {
      path: RoutesMap.login.otp,
      element: <OtpPage />,
      loader: OtpPage.loader,
    }, {
      path: RoutesMap.login.passport,
      element: <PassportPage />,
      loader: PassportPage.loader,
    }, {
      path: RoutesMap.login.pin,
      element: <PinPage />,
      loader: PinPage.loader,
    },],
  },],
},],);
